import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import GradientChip from '../GradientChip';
import { getExecutiveBriefData } from '../../../../utils/aiBriefingsData';
interface ExecutiveBriefWidgetProps {
  onExpand?: () => void;
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const ExecutiveBriefWidget: React.FC<ExecutiveBriefWidgetProps> = ({
  onExpand,
  onHide,
  onAsk
}) => {
  const data = getExecutiveBriefData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Perché è cambiato?'
  }, {
    id: '2',
    text: 'Quali sono i driver principali?'
  }, {
    id: '3',
    text: 'Cosa posso fare per migliorare?'
  }, {
    id: '4',
    text: 'Confronta con mese scorso'
  }];
  return <BentoWidgetCard id="executive-brief" title="Executive Brief" size="L" lastUpdated="2 min fa" questions={questions} onExpand={onExpand} onHide={onHide} onAsk={onAsk} data-id="element-1390">
      {/* KPIs Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4" data-id="element-1391">
        {data.kpis.map((kpi, index) => <div key={index} className="bg-gray-50 rounded-lg p-3" data-id="element-1392">
            <p className="text-xs text-gray-600 mb-1" data-id="element-1393">{kpi.label}</p>
            <p className="text-lg font-bold text-gray-900" data-id="element-1394">{kpi.value}</p>
            {kpi.change !== undefined && <div className="flex items-center gap-1 mt-1" data-id="element-1395">
                {kpi.trend === 'up' ? <TrendingUp className="h-3 w-3 text-green-600" data-id="element-1396" /> : <TrendingDown className="h-3 w-3 text-red-600" data-id="element-1397" />}
                <span className={`text-xs font-medium ${kpi.trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-1398">
                  {kpi.change > 0 ? '+' : ''}
                  {kpi.change}%
                </span>
              </div>}
          </div>)}
      </div>

      {/* Narrative */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4" data-id="element-1399">
        <p className="text-xs font-semibold text-blue-900 mb-2" data-id="element-1400">
          Cosa è cambiato
        </p>
        <p className="text-sm text-blue-800" data-id="element-1401">{data.narrative}</p>
      </div>

      {/* Drivers */}
      <div className="mb-4" data-id="element-1402">
        <div className="flex items-center gap-2 mb-3" data-id="element-1403">
          <p className="text-xs font-semibold text-gray-900" data-id="element-1404">
            Driver Principali
          </p>
          <GradientChip size="xs" data-id="element-1405">Insight AI</GradientChip>
        </div>
        <div className="space-y-2" data-id="element-1406">
          {data.drivers.map((driver, index) => <div key={index} className="flex items-center justify-between bg-gray-50 rounded-lg p-2" data-id="element-1407">
              <div className="flex-1" data-id="element-1408">
                <p className="text-sm font-medium text-gray-900" data-id="element-1409">
                  {driver.title}
                </p>
                <p className="text-xs text-gray-600" data-id="element-1410">{driver.impact}</p>
              </div>
              <div className="flex items-center gap-1" data-id="element-1411">
                <TrendingUp className="h-3 w-3 text-green-600" data-id="element-1412" />
                <span className="text-xs font-bold text-green-600" data-id="element-1413">
                  +{driver.change}%
                </span>
              </div>
            </div>)}
        </div>
      </div>

      {/* Trend Chart */}
      <div data-id="element-1414">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1415">
          Trend 30 giorni
        </p>
        <div className="h-32" data-id="element-1416">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1417">
            <LineChart data={data.trend} data-id="element-1418">
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1419" />
              <XAxis dataKey="date" stroke="#6B7280" fontSize={10} tickFormatter={value => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }} data-id="element-1420" />
              <YAxis stroke="#6B7280" fontSize={10} data-id="element-1421" />
              <Tooltip contentStyle={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #E5E7EB',
              borderRadius: '0.5rem',
              fontSize: '12px'
            }} data-id="element-1422" />
              <Line type="monotone" dataKey="value" stroke="#16A34A" strokeWidth={2} dot={false} data-id="element-1423" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </BentoWidgetCard>;
};
export default ExecutiveBriefWidget;